import React from "react";

import { UserPill, UserPillUser } from "@/components/user-pill/user-pill";

export const Follows = ({
  users,
  title,
}: {
  title: string;
  users: (UserPillUser & { id: string })[];
}) => {
  if (!users?.length) return null;

  return (
    <div className="text-sm bg-white bg-opacity-50 rounded-md mb-2 shadow-md">
      <div className="bg-white rounded-t-md px-2 font-bold">{title} ({users.length})</div>
      <div className="p-2">
        {users.map((user) => (
          <UserPill user={user} key={user.id} small />
        ))}
      </div>
    </div>
  );
};
